import { Box, Typography, Divider, Theme, SxProps } from '@mui/material';

type FieldRowProps = Readonly<{
  label: string;
  children: React.ReactNode;
  hideDivider?: boolean;
}>;

export const FieldRow = ({ label, children, hideDivider }: FieldRowProps) => (
  <>
    {!hideDivider && <Divider sx={dividerSx} />}

    <Box sx={nameContainerSx} gap={hideDivider ? 3 : 0}>
      <Typography sx={fieldLabelSx}>{label}</Typography>
      <Box sx={fieldsContainerSx}>{children}</Box>
    </Box>
  </>
);

const nameContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: { xs: 'column', sm: 'row' },
  gap: { xs: backrs.spacing['spacing-md'], sm: backrs.spacing['spacing-2xl'] },
});

const fieldLabelSx: SxProps<Theme> = ({ typography }) => ({
  minWidth: 250,
  ...typography['text-sm-semibold'],
});

const fieldsContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: { xs: backrs.spacing['spacing-md'], sm: backrs.spacing['spacing-2xl'] },
  flex: 1,
  maxWidth: '512px',
  flexDirection: { xs: 'column', sm: 'row' },
});

const dividerSx: SxProps<Theme> = ({ backrs }) => ({
  my: backrs.spacing['spacing-none'],
});
